import { render, staticRenderFns } from "./TrialBalanceView.vue?vue&type=template&id=5dae2468&scoped=true"
import script from "./TrialBalanceView.vue?vue&type=script&lang=js"
export * from "./TrialBalanceView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dae2468",
  null
  
)

export default component.exports